import { Text } from '@chakra-ui/react';
import { GET_STATIC_CONTENT, SITE_BB } from '@whitbread-eos/api';
import { useCustomLocale, useQueryRequest } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import HeaderVariantStepContainer from '../HeaderLeisure/HeaderVariantStep/HeaderVariantStep.container';
import HeaderBusinessVariantDefault from './HeaderBusinessVariantDefault';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HeaderBusiness(_ref) {
  var variant = _ref.variant,
    queryClient = _ref.queryClient;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useQueryRequest = useQueryRequest(['GetStaticContent', language, country], GET_STATIC_CONTENT, {
      language,
      country,
      site: SITE_BB,
      businessBooker: true
    }),
    BBHeaderInfo = _useQueryRequest.data,
    isLoading = _useQueryRequest.isLoading;
  if (isLoading) {
    return _jsx(Text, {
      style: {
        display: 'none'
      },
      children: t('searchresults.list.hotel.loading')
    });
  }
  return renderHeader(BBHeaderInfo, variant, queryClient);
}
function renderHeader(BBHeaderInfo, variant, queryClient) {
  switch (variant) {
    case 'business-step':
      {
        return _jsx(HeaderVariantStepContainer, {
          headerInfoData: BBHeaderInfo.headerInformation,
          queryClient: queryClient,
          bb: true
        });
      }
    case 'business-default':
    default:
      {
        return _jsx(HeaderBusinessVariantDefault, {
          BBHeaderInfo: BBHeaderInfo.headerInformation
        });
      }
  }
}